<template>
        <div class="edits setting">
            <div class="setting-h1">
                Account Type
            </div>
            <div class="setting-h2">
                Fundamentally change what your account type is (Job Seeker/Employer).
            </div>
        <form>
    
          <div class="mb-3">
                <label class="form-label">Who Are You?</label>
                    <select class="form-select" aria-label="Default select example">
                    <option value="Job Seeker">Job Seeker</option>
                    <option value="Employeer">Employeer</option>
                    <!-- <option value="Both">Job Seeker & Employeer</option> -->
                    </select>
        </div>  
         <div class="form-buttons mb-3">
                <button class="btn btn-default primary-btn">Save Account</button>
            </div>
            <!-- <ErrorMessages messages="years"/> -->
        </form>
        <LoadingIndicator/>
        </div>
</template>
<script>
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';

export default {
    components:{
        LoadingIndicator
    }
}
</script>
<style scoped>

.edit-profile{
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    margin:4.5rem 0rem;
}

.edits{
    grid-column:2/3;
}

    .select-dates, .select-date{
    display: flex;
    
}

.select-date{
    column-gap:0.5rem;
}

.select-dates{
    row-gap:0.8rem;
    align-items: flex-start;
    flex-direction: column;
}

select{
    min-width:9rem;
}

@media (max-width:768px) {
    .edits{
    grid-column:1/4;
    margin:0rem 0.8rem;
}
}
</style>